export const TEXT = {
    VERIFYING_LINK: 'Verifying Link',
    LOADING: 'loading',
    VALID: 'valid',
    INVALID: 'invalid',
    EXPIRED: 'expired'
};